import React, { ReactNode } from "react";
import { ConfigProvider, theme as AntdTheme, ThemeConfig } from "antd";
import { AliasToken } from "antd/es/theme/interface";
import { seedTokens, mapTokens, componentTokens } from "./tokens";

const { defaultAlgorithm, darkAlgorithm } = AntdTheme;

export interface ThemeProviderProps {
    theme?: "default" | "dark";
    tokens?: Partial<AliasToken>;
    children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
    theme = "default",
    tokens = {},
    children,
}) => {
    /**
     * Combine tokens precedence
     * User > Design system > AntD
     *
     * seedTokens, mapTokens are values provided by this design-system based on general PhonePe use case
     * tokens are provided by user of this design system like PhonePe merchant team to modify based on their use case
     */
    const designTokens = {
        ...seedTokens,
        ...mapTokens,
        ...tokens,
    };

    const themeConfig: ThemeConfig = {
        token: designTokens,
        algorithm: theme === "dark" ? darkAlgorithm : defaultAlgorithm,
        components: componentTokens,
    };

    return <ConfigProvider theme={themeConfig}>{children}</ConfigProvider>;
};
